
<!--
IMPORTANT:
This file is used only in the vue3 application
Any changes made here should be do in the vue2 file also
Any clarifications contact sai krishna

Vue2File : wwwroot\js\components\rotaionalspecialbanner\RotationalSpecialsContainer\RotationalSpecialsContainer.vue
-->
<template>
    <div>
         <component :is="componentName" v-if="componentName"></component>
    </div>
</template>

<script src="./RotationalSpecialsContainer.js" type="text/javascript"></script>